
const FolderWindow = ({ title, files, onClose, onFileClick, header = [], toolbar = [], sidebar = [] }) => {
  return (
    <div className="absolute top-[6%] left-[7%] bg-[#1F293770] w-[800px] h-[510px] rounded-3xl shadow-lg z-10 backdrop-blur-[10px] flex flex-col">

      {/* Header */}
      <div className="flex justify-between items-center px-4">
        <div className="relative flex items-center rounded-t-[18px] bg-[#D9D9D9] mt-4 gap-1.5 p-2 px-4 opacity-85">
          <img src="/storage/game/system-icons/mistnidiskccerny.svg" alt={title} className="w-5 h-5" />
          <h3 className="text-lg font-semibold text-[#1F2937]">{title}</h3>
        </div>
        <div className="flex gap-1.5">
          {header.map((btn, idx) => (
            <button
              key={idx}
              onClick={() => {
                if (btn.action === 'close') {
                  onClose?.();
                } else if (btn.onClick) {
                  btn.onClick(btn.action);
                }
              }}
              className={`px-2 py-1 rounded ${
                btn.action ? 'cursor-pointer hover:bg-white/20' : 'cursor-not-allowed opacity-50'
              }`}
            >
              <img src={btn.icon} alt={btn.label || btn.action} className="w-5 h-5" />
            </button>
          ))}
        </div>
      </div>


      {/* Toolbar */}
      <div className="px-4">
        <div className="flex gap-4 py-3 px-3 rounded-r-[18px] rounded-bl-[18px] bg-[#D9D9D9] opacity-85">
          {toolbar.map((btn, idx) => (
            <button
              key={idx}
              className="flex items-center gap-1 text-[#1F2937] px-2 py-1 rounded hover:bg-white/50"
              onClick={() => btn.action && btn.onClick?.(btn.action)}
            >
              <img src={btn.icon} alt={btn.label} className="w-5 h-5" />
              <span className="text-[16px]">{btn.label}</span>
            </button>
          ))}
        </div>
      </div>
      

      <div className="flex flex-1 overflow-hidden p-4">
        {/* Sidebar */}
        <div className="w-48 bg-[#00000040] p-3 px-4 flex flex-col gap-1.5 text-white rounded-[18px]">
          {sidebar.map((item, idx) => (
            <div key={idx}>
              <button
                className="flex items-center gap-2 p-1 hover:bg-white/20 rounded"
                onClick={() => item.action && item.onClick?.(item.action)}
              >
                <img src={item.icon} alt={item.label} className="w-5 h-5" />
                <span className="text-[16px]">{item.label}</span>
              </button>

              {/* Divider */}
              {item.divider && <hr className="border-t border-white/30 my-2" />}
            </div>
          ))}
        </div>


         {/* Content */}
      <div className="flex-1 p-3 overflow-y-auto text-white">
        <div className="grid grid-cols-5 gap-4">
          {files.map((file, idx) => (
            // <button
            //   key={idx}
            //   onClick={() => onFileClick?.(file)}   // 🔹 přidáme callback
            //   className="flex flex-col items-center hover:bg-white/10 rounded p-2 cursor-pointer"
            // >
            //   <img src={file.icon} alt={file.label} className="w-12 h-12" />
            //   <span className="text-sm mt-2">{file.label}</span>
            // </button>
            <button
            key={idx}
            className="flex flex-col items-center gap-1 w-24 p-2 hover:bg-white/10 rounded cursor-pointer"
            onClick={() => onFileClick(file)}
          >
            <img src={file.icon} alt={file.label} className="w-10 h-10" />
            <span className="text-white text-sm text-center">{file.label}</span>
          </button>

          ))}
        </div>
      </div>


      </div>
    </div>
  );
};

export default FolderWindow;
